import { render, staticRenderFns } from "./Fbbuy.vue?vue&type=template&id=9a833f9e&"
import script from "./Fbbuy.vue?vue&type=script&lang=js&"
export * from "./Fbbuy.vue?vue&type=script&lang=js&"
import style0 from "./Fbbuy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports